import React from 'react';

const Loader = () => {
    return (
        <div className="absolute bg-[#333] bg-opacity-60 z-[999] h-full w-full flex items-center justify-center">
            <div className="flex items-center">
                <div
                    className="inline-block h-52 w-52 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] text-gray-300"
                    role="status">
                </div>
            </div>
        </div>
    );
};

export default Loader;